import styled from 'styled-components';
import headerDesktop from 'assets/images/header-desktop.jpg';
import headerMobile from 'assets/images/header-mobile.jpg';

export const Container = styled.header`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 100vh;
  background-color: #9fb6ee;
  margin: 0 auto;
  padding: 42px 0;

  @media screen and (max-width: 500px) {
    height: auto;
    padding: 0;
    background-color: transparent;
    min-height: 0;
  }
`;

export const HeaderDesktop = styled.img.attrs({ src: headerDesktop })`
  width: 100%;
  height: 100%;
  margin-bottom: 16px;

  @media screen and (max-width: 500px) {
    display: none;
  }
`;
export const HeaderMobile = styled.img.attrs({ src: headerMobile })`
  display: none;
  width: 100%;
  margin-bottom: 16px;

  @media screen and (max-width: 500px) {
    display: block;
  }
`;

export const Caption = styled.div`
  max-width: 410px;
  font-size: 14px;
  text-align: center;

  p.mobile {
    display: none;
  }

  @media screen and (max-width: 500px) {
    padding: 0 40px;
    p.desktop {
      display: none;
    }
    p.mobile {
      display: block;
    }
  }
`;
